import { render, staticRenderFns } from "./DetailsTicketApprovalBox.vue?vue&type=template&id=8e0adb5c"
import script from "./DetailsTicketApprovalBox.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketApprovalBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports